export default __webpack_public_path__ + "static/media/verify_bg1.ddc429fb.png";